// v3.9.00: barra global de progresso do bootstrap inicial.
import React from "react";

const STEPS = ["Preparando", "Hidratando", "Salvando", "Conferindo", "Pronto"];

function stepIdx(status, progress) {
  if (status === "ready") return 4;
  if (status === "post_delta_checking" || status === "post_delta_failed") return 3;
  if (status === "snapshot_completed") return 2;
  if (status === "snapshot_in_progress") return progress > 40 ? 2 : 1;
  return 0;
}

export function BootstrapProgressBar({ state, onRetry, T = {} }) {
  if (!state) return null;
  const { status } = state;
  if (!status || status === "not_started" || status === "ready" || status === "aborted") return null;

  const pct = Math.min(100, Math.max(0, Number(state.progress) || 0));
  const idx = stepIdx(status, pct);
  const failed = status === "post_delta_failed";
  const accent = failed ? (T.red || "#ef4444") : (T.accent || "#3b82f6");
  const bg = T.surface2 || "#1e293b";
  const fg = T.text || "#f1f5f9";
  const muted = T.muted || "#94a3b8";

  return (
    <div style={{ position: "sticky", top: 0, zIndex: 9999, background: bg,
      borderBottom: `1px solid ${accent}33`, padding: "8px 16px",
      display: "flex", flexDirection: "column", gap: 6 }}>

      <div style={{ display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap" }}>
        <span style={{ fontSize: 11, color: muted, marginRight: 4 }}>
          {failed ? "Conferência falhou —" : "Sincronizando base inicial ·"}
        </span>
        {STEPS.map((label, i) => {
          const done = i < idx;
          const active = i === idx;
          return (
            <React.Fragment key={label}>
              <span style={{ fontSize: 11, fontWeight: active ? 700 : 400,
                color: done ? accent : active ? fg : muted }}>
                {done ? "✓" : active ? "●" : "○"} {label}
              </span>
              {i < STEPS.length - 1 && <span style={{ fontSize: 11, color: muted }}>──</span>}
            </React.Fragment>
          );
        })}
      </div>

      <div style={{ height: 4, background: `${accent}33`, borderRadius: 2, overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${pct}%`, background: accent,
          borderRadius: 2, transition: "width 0.4s ease" }} />
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
        <span style={{ fontSize: 11, color: muted }}>
          {failed
            ? "A conferência final falhou. Edição bloqueada até tentar novamente."
            : `${pct}% · Visualização liberada. Edição bloqueada até finalizar.`}
        </span>
        {failed && onRetry && (
          <button onClick={onRetry} style={{ fontSize: 11, padding: "2px 10px",
            borderRadius: 6, cursor: "pointer", background: accent, color: "#fff", border: "none" }}>
            Tentar novamente
          </button>
        )}
      </div>
    </div>
  );
}
